import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { FlexColumn } from "@opensea/ui-kit";
import { CurrencyStatsTableRowOneHourPriceChange, CurrencyStatsTableRowOneHourPriceChangeFragment } from "@/components/stats/CurrencyStatsTable/CurrencyStatsTableRowOneHourPriceChange";
import { CurrencyStatsTableRowPrice, CurrencyStatsTableRowPriceFragment } from "@/components/stats/CurrencyStatsTable/CurrencyStatsTableRowPrice";
export const CurrencyStatsTableRowPriceMobileFragment = graphql(`
    fragment CurrencyStatsTableRowPriceMobile on Currency {
      ...CurrencyStatsTableRowPrice
      ...CurrencyStatsTableRowOneHourPriceChange
    }
  `, [CurrencyStatsTableRowPriceFragment, CurrencyStatsTableRowOneHourPriceChangeFragment]);
export function CurrencyStatsTableRowPriceMobile(t0) {
  const $ = _c(4);
  const {
    currency: currencyKey
  } = t0;
  let t1;
  if ($[0] !== currencyKey) {
    t1 = readFragment(CurrencyStatsTableRowPriceMobileFragment, currencyKey);
    $[0] = currencyKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currency = t1;
  let t2;
  if ($[2] !== currency) {
    t2 = <FlexColumn className="items-end"><CurrencyStatsTableRowPrice currency={currency} /><CurrencyStatsTableRowOneHourPriceChange currency={currency} /></FlexColumn>;
    $[2] = currency;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}